<div class="app-container">
  <div class="navbar fixed-top logo"></div>
  <!-- <div class="navbar fixed-top">Env version: {{ environment.environmentVersion }}</div> -->
  <router-outlet></router-outlet>
</div>
